import { rpc } from 'rpc-mini'
import { debugObjectMethods } from 'everyday-utils'
import { getSharedWorkerPort } from 'monolang'
import { EditorBuffer } from './editor-buffer'
import { Waveplot } from './waveplot'
import { queue } from 'minimal-view'
import { services } from './services'

let worker: Worker
export function getPreviewPort() {
  worker ??= new Worker(
    // @ts-ignore
    new URL('./preview-worker.js', import.meta.url),
    { type: 'module' }
  )
  return worker
}

export interface Preview {
  fetchSample(sample: number): Promise<Float32Array[] | undefined>
  draw(buffer: EditorBuffer): Promise<Error | void | false>
}

export function createPreview(waveplot: Waveplot, sampleRate: number): Preview {
  const worker = getPreviewPort()

  const api = debugObjectMethods({
    fetchSample: async (sample: number) => {
      const result = await services.$.audio!.$.fetchSample(`${sample}`)
      if (!result) return
      return result.channelsFloats
    },
    draw: queue.atomic(async (buffer) => {
      const id = buffer.$.id!
      try {
        const res: boolean | { inputChannels: number, outputChannels: number } = await remote(
          'fillPreview',
          id,
          buffer.$.value,
          waveplot.targets.get(id)!.floats
        )

        if (!res) return

        if (typeof res === 'object') {
          buffer.$.inputChannels = res.inputChannels
          buffer.$.outputChannels = res.outputChannels
        }
      } catch (error) {
        console.error(error)
        return error as Error
      }

      return waveplot.draw(id)
    }),
  }, [], {
    before: (key, args) => {
      console.log(key, args)
    },
    after: () => { }
  }, 'preview-service')

  const remote = rpc(worker as unknown as MessagePort, api)

  remote('setPort', getSharedWorkerPort())
  remote('setArgContext', {
    sampleRate,
    beatSamples: sampleRate,
    numberOfBars: 1
  })

  return api
}
